import cookies from 'js-cookie';

export const getAccessToken = (): string | null => {
  const accessToken = cookies.get('accessToken');
  if (accessToken) {
    return JSON.parse(accessToken).value;
  }

  return null;
};
